module.exports = __webpack_public_path__ + "static/media/neva_ipad.ceede46a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/neva/neva_ipad.png
// module id = 345
// module chunks = 0